module.exports = __webpack_public_path__ + "static/media/fitball.c6904678.png";